import React from 'react';

const fmt = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n.toFixed(2) : '0.00';
};

/**
 * 订单结算明细展示
 */
export default function SettlementSummary({ settlement, compact = false }) {
    if (!settlement) {
        return null;
    }

    const goods = settlement.goodsOriginalAmount ?? 0;
    const flash = settlement.flashSaleDiscount ?? 0;
    const full = settlement.fullReductionDiscount ?? 0;
    const discount = settlement.discountCampaignDiscount ?? 0;
    const campaignTotal = settlement.campaignDiscountTotal ?? (flash + full + discount);
    const coupon = settlement.couponDiscount ?? 0;
    const points = settlement.pointsDiscount ?? 0;
    const shipping = settlement.shippingFee ?? 0;
    const pay = settlement.payAmount ?? goods;

    const rows = [
        { label: '商品金额', value: goods, highlight: false },
    ];
    if (flash > 0) {
        rows.push({
            label: settlement.appliedFlashCampaignName ? `限时活动（${settlement.appliedFlashCampaignName}）` : '限时活动优惠',
            value: -flash,
            highlight: true,
        });
    }
    if (full > 0) {
        rows.push({
            label: settlement.appliedOrderCampaignName ? `满减活动（${settlement.appliedOrderCampaignName}）` : '满减优惠',
            value: -full,
            highlight: true,
        });
    }
    if (discount > 0) {
        rows.push({
            label: '折扣活动优惠',
            value: -discount,
            highlight: true,
        });
    }
    if (campaignTotal > 0 && flash === 0 && full === 0 && discount === 0) {
        rows.push({ label: '活动优惠', value: -campaignTotal, highlight: true });
    }
    if (coupon > 0) {
        rows.push({
            label: settlement.appliedCouponName ? `优惠券（${settlement.appliedCouponName}）` : '优惠券抵扣',
            value: -coupon,
            highlight: true,
        });
    }
    if (points > 0) {
        rows.push({
            label: settlement.pointsToUse ? `积分抵扣（${settlement.pointsToUse}分）` : '积分抵扣',
            value: -points,
            highlight: true,
        });
    }
    rows.push({
        label: '运费',
        value: shipping,
        // 始终展示金额，避免未计运费时误导为「免运费」
        display: `¥${fmt(shipping)}`,
        displayClass: shipping > 0 ? 'text-gray-900 dark:text-gray-100' : 'text-gray-600',
    });

    return (
        <div className={`space-y-1 ${compact ? 'text-xs' : 'text-sm'}`}>
            {rows.map((row) => (
                <div key={row.label} className="flex justify-between text-gray-600 dark:text-gray-400">
                    <span>{row.label}</span>
                    {row.display ? (
                        <span className={row.displayClass || 'text-green-600'}>{row.display}</span>
                    ) : (
                        <span className={row.highlight ? 'text-orange-600' : ''}>
                            {row.value < 0 ? `-¥${fmt(Math.abs(row.value))}` : `¥${fmt(row.value)}`}
                        </span>
                    )}
                </div>
            ))}
            <div className={`flex justify-between font-semibold border-t border-gray-200 dark:border-gray-600 pt-2 mt-2 ${compact ? 'text-sm' : 'text-base'}`}>
                <span className="text-gray-900 dark:text-white">实付金额</span>
                <span className="text-red-600">¥{fmt(pay)}</span>
            </div>
            {settlement.stackingNotes?.length > 0 && (
                <div className="mt-2 text-xs text-amber-600 space-y-0.5">
                    {settlement.stackingNotes.map((note, i) => (
                        <div key={i}>· {note}</div>
                    ))}
                </div>
            )}
        </div>
    );
}
